import {
  fetchBannersWithImages,
  selectBannersWithImages,
} from "features/admin/Banners/bannersAdminSlice";
import React, { useEffect } from "react";
import Swiper from "react-id-swiper";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import styled from "styled-components/macro";
import SwiperCore, { Autoplay } from "swiper";
import "swiper/swiper-bundle.min.css";
import { device } from "theme/Breakpoints";
import { colors } from "theme/Theme";
import BannerItem from "./BannerItem";

const Banner = () => {
  const banners = useSelector(selectBannersWithImages);
  const dispatch = useDispatch();
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const isSitemap = location.pathname?.includes("sitemap");
  const isLogin = location.pathname?.includes("asparuh");
  useEffect(() => {
    banners.length === 0 && dispatch(fetchBannersWithImages());
  }, []);

  const params = {
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  };
  SwiperCore.use([Autoplay]);

  if (isSitemap || isLogin || !isHomePage) {
    return null;
  }
  return banners && banners.length !== 0 ? (
    <Swiper {...params}>
      {banners.map((item: any, idx: string | number | null | undefined) => {
        return (
          <Wrapper key={idx}>
            <BannerItem data={item} />
          </Wrapper>
        );
      })}
    </Swiper>
  ) : (
    <Loader />
  );
};
const Wrapper = styled.div`
  width: inherit;
  height: inherit;
`;

const Loader = styled.div`
  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }
  width: inherit;
  height: 250px;

  text-align: center;
  @media only screen and (${device.tablet}) {
    height: 300px;
  }
  @media only screen and (${device.laptop}) {
    height: 442px;
  }
  animation-duration: 1.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: ${colors.gray};
  background: linear-gradient(to right, #f6f6f6 8%, #f0f0f0 18%, #f6f6f6 33%);
  background-size: 800px 104px;
  height: 96px;
  position: relative;
`;
export default Banner;
